import * as React from 'react';
import { useOfferContext } from '../../../context';
import { PessimizationFlexible } from '../../../components/PessimizationFlexible';

export const PessimizationFlexibleContainer = () => {
  const {
    offer: { moderationInfo },
  } = useOfferContext();

  if (!moderationInfo?.warningMessage) {
    return null;
  }

  return <PessimizationFlexible warningMessage={moderationInfo.warningMessage} />;
};

PessimizationFlexibleContainer.displayName = 'PessimizationFlexibleContainer';
